export const SHOP_SET_FILTER = 'SHOP_SET_FILTER';
export const SHOP_CLEAR_SEARCH = 'SHOP_CLEAR_SEARCH';
